import React, { Component } from 'react'
import { Modal, Table, Row, Col, Input, InputNumber, Select, Button, message, TimePicker, DatePicker, Divider, Switch } from 'antd'
import airports from './../../../airports';
import country from './../../../countries';
import moment from 'moment';
import _ from 'underscore';
import { connect } from 'react-redux';
import { getCookie } from './../../../hook';

// Actions
import { save_travel } from './../actions/travel.action'

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
const TextArea = Input.TextArea;
const { Option } = Select;
const format = 'HH:mm';
const dateFormat = 'YYYY/MM/DD';
let timer;
class NewTravel extends Component {

    constructor( props ){
        super( props )

        this.state = {
            data: [],
            destinations: [],
            hotels: [],
            departure_location_list: [],
            arrival_location_list: [],
            departure_location: '',
            departure_date: '',
            departure_time: '',
            arrival_location: '',
            arrival_date: '',
            arrival_time: '',
            destination_visible: false,
            hotel_visible: false,
            personal_travel: false,
            personal_travel_start_date: '',
            personal_travel_end_date: '',
            purpose_of_visit: '',
            travel_advance: false,
            travel_advance_amount: 0,
            visa_required: false,
            visa_details: '',
            hotel_required: false,
            remarks: '',
            others: '',
            hotel_location: '',
            hotel_check_in: '',
            hotel_check_out: ''
        }

        this.handleDepartureSearch = this.handleDepartureSearch.bind( this );
        this.handleArrivalSearch = this.handleArrivalSearch.bind( this );
        this.handleDestination = this.handleDestination.bind( this );
        this.handleDestinationModal = this.handleDestinationModal.bind( this );
        this.handleCancelDestinationModal = this.handleCancelDestinationModal.bind( this );
        this.handleDeleteDestination = this.handleDeleteDestination.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleHotelModal = this.handleHotelModal.bind( this );
        this.handleCancelHotelModal = this.handleCancelHotelModal.bind( this );
        this.handleHotel = this.handleHotel.bind( this );
        this.handleDeleteHotel = this.handleDeleteHotel.bind( this );
        this.handleCancelPage = this.handleCancelPage.bind( this );

    }

    handleCancelPage(){
        this.props.history.goBack();
    }

    handleDeleteHotel( key ){
        let data_des = this.state.hotels;
        var filtered = _.filter(data_des, function(item) {
            return item.key !== key
        });

        this.setState({
            hotels: filtered
        })
    }

    handleHotel(){
        this.setState({ hotel_visible: true });
    }

    handleHotelModal(){
        let data_des = this.state.hotels;
        let index = new Date().getTime();

        if( this.state.hotel_location &&
            this.state.hotel_check_in &&
            this.state.hotel_check_out ){

                let temp_data = {
                    key: index,
                    hotel_location: this.state.hotel_location,
                    hotel_check_in: this.state.hotel_check_in,
                    hotel_check_out: this.state.hotel_check_out,
                }
        
                data_des.push( temp_data );
        
                this.setState({
                    hotels: data_des,
                    hotel_visible: false,
                    hotel_location: '',
                    hotel_check_in: '',
                    hotel_check_out: ''
                });

        } else {
            message.error( 'All fields are mandatory' );
        }

    }

    handleCancelHotelModal(){
        this.setState({ hotel_visible: false });
    }

    handleSubmit(){

        let user = getCookie('dv_hrms_user').split(',');

        if( this.state.destinations.length === 0 ){
            message.error("Trip details are required!");
            return false;
        }
        
        if( this.state.hotel_required === true ){
            if( this.state.hotels.length === 0 ){
                message.error("Hotel details are required!");
                return false;
            }
        }

        let temp_data = {
            user_id: user[1],
            user_email: user[2],
            user_full_name: user[4],
            destinations: this.state.destinations,
            personal_travel: this.state.personal_travel,
            personal_travel_end_date: this.state.personal_travel_end_date,
            personal_travel_start_date: this.state.personal_travel_start_date,
            purpose_of_visit: this.state.purpose_of_visit,
            travel_advance: this.state.travel_advance,
            travel_advance_amount: this.state.travel_advance_amount,
            visa_required: this.state.visa_required,
            visa_details: this.state.visa_details,
            hotel_required: this.state.hotel_required,
            hotels: this.state.hotels,
            remarks: this.state.remarks,
            others: this.state.others
        }

        this.props.save_travel( temp_data );
        
    }

    handleDeleteDestination( key ){

        let data_des = this.state.destinations;
        var filtered = _.filter(data_des, function(item) {
            return item.key !== key
        });

        this.setState({
            destinations: filtered
        })

    }

    handleDestinationModal(){
        let data_des = this.state.destinations;
        let index = new Date().getTime();

        if( this.state.departure_location &&
            this.state.departure_date &&
            this.state.departure_time &&
            this.state.arrival_location &&
            this.state.arrival_date &&
            this.state.arrival_time ){

                let temp_data = {
                    key: index,
                    departure_location: this.state.departure_location,
                    departure_date: this.state.departure_date,
                    departure_time: this.state.departure_time,
                    arrival_location: this.state.arrival_location,
                    arrival_date: this.state.arrival_date,
                    arrival_time: this.state.arrival_time
                }
        
                data_des.push( temp_data );
        
                this.setState({
                    destinations: data_des,
                    departure_location: '',
                    departure_date: '',
                    departure_time: '',
                    arrival_location: '',
                    arrival_date: '',
                    arrival_time: '',
                    destination_visible: false
                });

        } else {
            message.error( 'All fields are mandatory' );
        }
        
        
    }

    handleCancelDestinationModal(){
        this.setState({ destination_visible: false });
    }

    handleDestination(){
        this.setState({ destination_visible: true });
    }

    handleArrivalSearch( value ){
        let self = this;
        clearTimeout(timer);
        timer = setTimeout(() => {

            let temp_data = airports.filter((el) => 
                el.name.toLowerCase().indexOf(value.toLowerCase()) > -1 
            );

            self.setState({ arrival_location_list: temp_data.slice(0, 10) });

        }, 700 );
    }

    handleDepartureSearch( value ){

        let self = this;
        clearTimeout(timer);
        timer = setTimeout(() => {

            let temp_data = airports.filter((el) => 
                el.name.toLowerCase().indexOf(value.toLowerCase()) > -1 
            );

            self.setState({ departure_location_list: temp_data.slice(0, 10) });

        }, 700 );
        
    }

    componentWillMount(){
        this.setState({
            departure_location_list: airports.slice(0, 10),
            arrival_location_list: airports.slice(0, 10)
        })
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.travel.length !== 0 ){
            if( nextProps.travel.STATUS.CODE === '200' &&
                nextProps.travel.STATUS.MESSAGE === 'Successfully Saved Travel' ){
                nextProps.history.goBack();
            }
        }
    }

    render() {

        const dep_airports_list = this.state.departure_location_list.map( (item, k) => <Option value={ item.name + " ("+ item.code +")" }>{ item.name + " ("+ item.code +")" }</Option> );
        const arv_airports_list = this.state.arrival_location_list.map( (item, k) => <Option value={ item.name + " ("+ item.code +")" }>{ item.name + " ("+ item.code +")" }</Option> );
        const country_list = country.countries.map( (item, key) => <Option value={ item.country }>{ item.country }</Option> )

        const destination_columns = [
            {
                title: 'Departure Location',
                dataIndex: 'departure_location',
                key: 'departure_location',
            },
            {
                title: 'Departure Date',
                dataIndex: 'departure_date',
                key: 'departure_date',
            },
            {
                title: 'Departure Time',
                dataIndex: 'departure_time',
                key: 'departure_time',
            },
            {
                title: 'Arrival Location',
                dataIndex: 'arrival_location',
                key: 'arrival_location',
            },
            {
                title: 'Arrival Date',
                dataIndex: 'arrival_date',
                key: 'arrival_date',
            },
            {
                title: 'Arrival Time',
                dataIndex: 'arrival_time',
                key: 'arrival_time',
            },{
                title: 'Action',
                dataIndex: '',
                render: (data)=> <Button 
                    icon="delete" 
                    type="danger" 
                    onClick={ ()=> this.handleDeleteDestination( data.key ) } />
            }
        ]

        const hotel_columns = [
            {
                title: 'Hotel Location',
                dataIndex: 'hotel_location',
                key: 'hotel_location',
            },
            {
                title: 'Departure Location',
                dataIndex: 'hotel_check_in',
                key: 'hotel_check_in',
            },
            {
                title: 'Departure Location',
                dataIndex: 'hotel_check_out',
                key: 'hotel_check_out',
            },{
                title: 'Action',
                dataIndex: '',
                render: (data)=> <Button 
                    icon="delete" 
                    type="danger" 
                    onClick={ ()=> this.handleDeleteHotel( data.key ) } />
            }
        ]

        return (
                <Row>

                    <h1>New Travel Requisition Form</h1>

                    <Divider />

                    <Col span={16}>

                        <Row>
                            <Col span={18}><h1>Trip Details</h1></Col>
                            <Col span={6}>
                                <label>&nbsp;</label>
                                <Button 
                                    onClick={ this.handleDestination }
                                    style={{width:'100%',backgroundColor: '#52c41a',color:'white',borderColor:'#48bd0e'}} icon="plus" type="default">Add Destination</Button>
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col span={24}>
                                <Table 
                                    pagination={false}
                                    size={"small"}
                                    columns={ destination_columns } 
                                    dataSource={ this.state.destinations } />
                            </Col>
                        </Row>
                        
                        <Divider />

                        <Row>
                            <Col span={12}>
                                <label>Was personal travel combined with this business trip?</label>
                                <br />
                                <Switch 
                                    onChange={ (value) => this.setState({ personal_travel: value }) }
                                    checkedChildren="Yes" unCheckedChildren="No" defaultChecked={ this.state.personal_travel} />
                            </Col>
                            <Col span={12}>
                                <label>If YES, please provide personal travel dates.</label>
                                <RangePicker 
                                    style={{width:'100%'}}
                                    onChange={ ( date, dateString ) => this.setState({
                                        personal_travel_start_date: dateString[0],
                                        personal_travel_end_date: dateString[1]
                                    }) } />
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <label>Purpose of visit</label>
                                <TextArea 
                                    onChange={ (e)=> this.setState({ purpose_of_visit: e.target.value }) }
                                    style={{width:'100%'}} value={this.state.purpose_of_visit} />
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col span={24}>
                                <h4><b><em>A travel advance is issued on an exceptional basis only.</em></b></h4>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <label>Travel advance required?</label>
                                <br />
                                <Switch 
                                    onChange={ (value)=> this.setState({travel_advance: value}) }
                                    checkedChildren="Yes" unCheckedChildren="No" defaultChecked={ this.state.travel_advance} />
                            </Col>
                            <Col span={12}>
                                <label>If YES, please state amount. <b>AED/-</b></label>
                                <Input
                                    type="number" step="any"
                                    onChange={ (e)=> this.setState({ travel_advance_amount: e.target.value }) }
                                    style={{width:'100%'}}
                                    value={this.state.travel_advance_amount} />
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <label>Is visa required?</label>
                                <br />
                                <Switch 
                                    onChange={ (value)=> this.setState({visa_required: value}) }
                                    checkedChildren="Yes" unCheckedChildren="No" defaultChecked={ this.state.visa_required} />
                            </Col>
                            <Col span={12}>
                                <label>If YES, please provide some details: </label>
                                <TextArea 
                                    onChange={ (e)=> this.setState({visa_details: e.target.value}) }
                                    style={{width:'100%'}} value={ this.state.visa_details} />
                            </Col>
                        </Row>

                        <Divider />

                        <Row>
                            <Col span={12}>
                                <label>Hotel Booking required?</label>
                                <br />
                                <Switch 
                                    onChange={ (value)=> this.setState({hotel_required: value})}    
                                    checkedChildren="Yes" unCheckedChildren="No" defaultChecked={this.state.hotel_required} />
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col span={20}>
                                <label>If YES, please fill up details below.</label>
                            </Col>
                            <Col span={4}>
                                <label>&nbsp;</label>
                                <Button 
                                    onClick={ this.handleHotel }
                                    style={{width:'100%',backgroundColor:'#52c41a',color:'white',borderColor:'#48bd0e'}} icon="plus" type="primary">Add Hotel</Button>
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col span={24}>
                                <Table 
                                    pagination={false}
                                    size={"small"}
                                    columns={ hotel_columns } 
                                    dataSource={ this.state.hotels} />
                            </Col>
                        </Row>

                        <Divider />

                        <Row gutter={10}>
                            <Col span={12}>
                                <label>Remarks</label>
                                <TextArea
                                    onChange={ (e)=> this.setState({remarks: e.target.value}) }
                                    style={{width:'100%'}} />
                            </Col>

                            <Col span={12}>
                                <label>Others</label>
                                <TextArea 
                                    onChange={ (e)=> this.setState({others: e.target.value})}
                                    style={{width:'100%'}} />
                            </Col>
                        </Row>
                        
                        <Divider />

                        <Row gutter={10}>
                            <Col span={3}>
                                <Button 
                                    onClick={this.handleCancelPage}
                                    style={{width:'100%'}}>Cancel</Button>
                            </Col>
                            <Col span={3}>
                                <Button 
                                    onClick={ this.handleSubmit }
                                    style={{width: '100%'}} type="primary">Save</Button>
                            </Col>
                        </Row>

                    </Col>

                    <Modal
                        title="Add Destination"
                        width={720}
                        maskClosable={ false }
                        visible={this.state.destination_visible}
                        onOk={ this.handleDestinationModal }
                        onCancel={ this.handleCancelDestinationModal }>
                        <div>
                            <Row gutter={10}>
                                <Col span={12}>
                                    <label>Departure Location</label>
                                    <Select
                                        showSearch
                                        style={{width:'100%'}}
                                        onSearch={ this.handleDepartureSearch }
                                        placeholder="Search Airport"
                                        onChange={ (value) => this.setState({departure_location: value}) }
                                        value={ this.state.departure_location }
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        { dep_airports_list }
                                    </Select>
                                </Col>
                                <Col span={12}>
                                    <label>Arrival Location</label>
                                    <Select
                                        showSearch
                                        style={{width:'100%'}}
                                        onSearch={ this.handleArrivalSearch }
                                        placeholder="Search Airport"
                                        onChange={ (value) => this.setState({arrival_location: value}) }
                                        value={ this.state.arrival_location }
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        { arv_airports_list }
                                    </Select>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col span={6}>
                                    <label>Date</label>
                                    <DatePicker 
                                        onChange={ (date, dateString) => this.setState({ departure_date: dateString }) }
                                        value={ moment( this.state.departure_date, dateFormat ) }
                                        style={{width: '100%'}} />
                                </Col>
                                <Col span={6}>
                                    <label>Preferred Time</label>
                                    <TimePicker 
                                        onChange={ (time, timeString) => this.setState({ departure_time: timeString }) }
                                        value={moment( (this.state.departure_time)? this.state.departure_time: '00:00', format)}
                                        style={{width: '100%'}} format={format} />
                                </Col>
                                <Col span={6}>
                                    <label>Date</label>
                                    <DatePicker 
                                        onChange={ (date, dateString) => this.setState({ arrival_date: dateString }) }
                                        value={ moment( this.state.arrival_date, dateFormat ) }
                                        style={{width: '100%'}} />
                                </Col>
                                <Col span={6}>
                                    <label>Preferred Time</label>
                                    <TimePicker 
                                        onChange={ (time, timeString) => this.setState({ arrival_time: timeString }) }
                                        value={moment( (this.state.arrival_time)? this.state.arrival_time: '00:00' , format)}
                                        style={{width: '100%'}} format={format} />
                                </Col>
                            </Row>
                            
                        </div>
                    </Modal>

                    <Modal
                        title="Add Hotel"
                        width={620}
                        maskClosable={ false }
                        visible={this.state.hotel_visible}
                        onOk={ this.handleHotelModal }
                        onCancel={ this.handleCancelHotelModal }>
                        <div>
                            <Row>
                                <Col span={24}>
                                    <Row gutter={10}>
                                        <Col span={12}>
                                            <label>Location ( Country )</label>
                                            <Select
                                                showSearch
                                                style={{width:'100%'}}
                                                onChange={ (value) => this.setState({hotel_location: value}) }
                                                value={ this.state.hotel_location }
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                { country_list}
                                            </Select>
                                        </Col>
                                        <Col span={12}>
                                            <label>Check In - Check Out</label>
                                            <RangePicker
                                                onChange={ (date, dateString ) => this.setState({
                                                    hotel_check_in: dateString[0],
                                                    hotel_check_out: dateString[1]
                                                })}
                                                style={{width: '100%'}} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Modal>

                </Row>
        )
    }
}

function mapStatetoProps( state ){
    return {
        travel: state.travel
    }
}

export default connect( mapStatetoProps,{ save_travel })( NewTravel );


// WEBPACK FOOTER //
// ./src/pages/travel/childs/new.travel.js